module.exports = __webpack_public_path__ + "static/media/dashboard-on-mtn.97555567.svg";